// AUPRÉA — Étapes 14/15 : constantes et petits composants partagés du tableau de bord « Bilans & clients »
import { createElement as h } from "react";
import axios from "axios";
import { C } from "./shared";
import { API, hdrs } from "./integrationShared";
import { getQuestionnaire } from "./parcoursQuestionnaires";

export const TYPES = { bilan_succession: "Bilan Succession", bilan_dirigeants: "Bilan Dirigeants", ouvrir_succession: "Ouvrir une succession", foncier_clair: "Foncier Clair" };
export const TERRITOIRES = ["Guadeloupe", "Martinique", "Guyane", "La Réunion", "Mayotte", "Outre-mer (autre)", "Hexagone", "Étranger", "Inconnu"];
export const TRANCHES = ["Moins de 40", "40–54", "55–69", "70 et plus", "Inconnue"];
export const F0 = { du: "", au: "", type: "", conseiller_id: "", equipe: false, territoire: "", tranche: "" };
export const STATUTS = { rdv_planifie: "RDV planifié", bilan_realise: "Bilan réalisé", proposition_envoyee: "Proposition envoyée", virement_attente: "Virement en attente", paye: "Payé", expiree: "Expirée", mission_en_cours: "Mission en cours", mission_terminee: "Mission terminée" };

const qs = (f) => new URLSearchParams(Object.entries(f || {}).filter(([, v]) => v !== "" && v !== false && v != null)).toString();
export const getB = (path, f) => axios.get(`${API}${path}?${qs(f)}`, hdrs()).then(r => r.data);
export const postB = (path, body) => axios.post(`${API}${path}`, body || {}, hdrs()).then(r => r.data);

export const qIndex = (type) => {
  const q = getQuestionnaire(type), idx = {};
  if (!q) return idx;
  const add = (sec, list) => (list || []).forEach(x => { idx[x.id] = { texte: x.texte || x.label, section: sec, options: x.options }; });
  (q.sections || []).forEach(s => add(s.titre, s.questions || s.champs));
  Object.values(q).forEach(v => { if (v && !Array.isArray(v) && typeof v === "object") add(v.titre, v.questions || v.champs); });
  return idx;
};

export const optLabel = (meta, v) => {
  const o = (meta?.options || []).find(o => (o?.value ?? o) === v);
  return o ? (o.label ?? o) : v;
};

export const Card = ({ title, children, testid, style }) => h("div", { "data-testid": testid, style: { background: "#fff", border: `.5px solid ${C.border}`, borderRadius: 12, padding: 16, ...style } },
  title && h("div", { style: { fontSize: 11, fontWeight: 700, color: C.mid, textTransform: "uppercase", letterSpacing: ".06em", marginBottom: 10 } }, title), children);

export const Stat = ({ label, value, sub, color = C.navy, testid }) => h("div", { style: { background: "#fff", border: `.5px solid ${C.border}`, borderTop: `3px solid ${color}`, borderRadius: 12, padding: 14 } },
  h("div", { style: { fontSize: 11, color: C.mid, textTransform: "uppercase" } }, label),
  h("div", { style: { fontSize: 24, fontFamily: "'Playfair Display', serif", color: C.navy }, "data-testid": testid }, value ?? "—"),
  sub && h("div", { style: { fontSize: 11, color: C.muted, marginTop: 2 } }, sub));

export const Barre = ({ parts }) => h("div", { style: { display: "flex", height: 10, borderRadius: 5, overflow: "hidden", background: C.gray, minWidth: 120 } },
  parts.filter(p => p[0] > 0).map(([v, col], i) => h("div", { key: i, style: { width: `${v}%`, background: col } })));

export const pctTxt = (v) => (v == null ? "—" : `${String(v).replace(".", ",")} %`);
export const nomC = (c) => { const p = (c?.prenom || "").trim(), n = (c?.nom || "").trim(); return p && n.toLowerCase().startsWith(p.toLowerCase()) ? n : `${p} ${n}`.trim(); };
export const th = { padding: 8, textAlign: "left", color: C.mid, fontSize: 10.5, textTransform: "uppercase", fontWeight: 600 };
export const td = { padding: 8, borderTop: `.5px solid ${C.border}`, verticalAlign: "top" };
